import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'
import { useTranslate } from 'react-admin'

const format = process.env.REACT_APP_DATEFORMAT ?? 'DD/MM/YYYY'

const useStyles = makeStyles({
  field: {
    fontSize: '13px',
    lineHeight: '15.23px',
  },
})

export const StatusDetailTitleField = ({
  source,
  record,
  basePath,
  ...props
}) => {
  const classes = useStyles()
  const translate = useTranslate()
  const futureDueDate = moment.utc(record.dueDate).isAfter(moment.utc())

  return (
    <div paragraph {...props} className={classes.field}>
      {source === 'OUTSTANDING' && futureDueDate && (
        <>
          {' '}
          {translate('resources.invoices.messages.advancedDescription').replace(
            '<<advancedDate>>',
            moment.utc(record.advancedDate).format(format)
          )}
        </>
      )}
      {source === 'OUTSTANDING' && !futureDueDate && (
        <>
          {' '}
          {translate('resources.invoices.messages.dueDescription').replace(
            '<<dueDate>>',
            moment.utc(record.dueDate).format(format)
          )}
        </>
      )}
      {source === 'PAID' && (
        <>
          {' '}
          {translate('resources.invoices.messages.paidDescription').replace(
            '<<lastPaymentDate>>',
            moment.utc(record.lastPaymentDate).format(format)
          )}
        </>
      )}
    </div>
  )
}
